<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3 class="pull-left">{{CPACommLan.text}}&nbsp;&nbsp;({{queryObj.REPORT_ID}})</h3>
        <div class="pull-right" style="margin-top:12px;">
          <el-button
            class="preview-btn"
            type="warning"
            round
            @click="$router.push('/ib_v2/CPACommissionResult')"
          >{{CPACommLan.goback}}</el-button>
        </div>
        <div class="clear"></div>
      </div>
      <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">
        <mtable
          v-if="trData"
          :thData="thData"
          :trData="trData"
          :page="page"
          :selPage="selPage"
          :link="link"
          :operate="operate"
          :back="back"
          :multiLanguage="CPACommLan"
          :downLoadTran="downLoadTran"
          :jsonExcelAjax="jsonExcelAjax"
          :name="name"
          @tableChange="tableAjax"
        >
          <div slot="handle" class="filterCond">
            <div class="commission-condition">
              <span>{{CPACommLan.status}}</span>
              <el-select v-model="status" style="width: 105px;" @change="searchDatas">
                <el-option
                  v-for="(key,val) in CPACommLan.CPAStatusList"
                  :key="val"
                  :label="key"
                  :value="val"
                ></el-option>
              </el-select>
            </div>
            <div class="commission-condition">
              <div class="commission-search">
                <span>{{CPACommLan.proxyAccount}}</span>
                <el-input v-model="proxyAccount" style="width:150px;"></el-input>
              </div>
              <div class="commission-search">
                <el-button type="primary" @click="searchDatas">{{CPACommLan.search}}</el-button>
              </div>
            </div>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>
<script>
import mtable from "../../comm/mytable";
import { getTimeDiff, updateTimeByUtc } from "common/js/util";
import { URL_CPA, URL_IBMONTHLYUPDATE } from "api/commissionApi";
import { Api } from "api/commissionEnv";
let api = new Api();

export default {
  name: "CPAMonthlyCommResult",
  mixins: [require("common/mixin/base.js").base({ CPACommLan: "cpaIBResult" })],
  props: ["curArea"],
  data() {
    return {
      trData: [],
      queryObj: {},
      status: "-1",
      proxyAccount: "",
      url: "",
      area: [],
      timeDiff: 0,
      loading: true,
      changeTime: false,
      link: {
        key: ["CPA_COMMISSION"],
        path: "CPAMonthlyCommDetailResult"
      },
      operate: {
        checkbox: true,
        url: api.getUrl20(this.curArea, URL_IBMONTHLYUPDATE),
        level: "IB"
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },
  computed: {
    back() {
      if (sessionStorage.getItem("back")) {
        let backObj = JSON.parse(sessionStorage.getItem("back"));
        backObj.secondBack = {
          status: this.status,
          proxyAccount: this.proxyAccount,
          report_id: this.queryObj.REPORT_ID,
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        };
        return JSON.stringify(backObj);
      }
    },
    name() {
      return this.CPACommLan.text;
    },
    thData() {
      return this.CPACommLan.computeTh;
    },
    downLoadTran() {
      return { STATUS: this.CPACommLan.CPAStatusList };
    },
    jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: "get",
        getKey: ["data", "data", "rows"],
        rID: this.queryObj.REPORT_ID,
        ajaxPar: {
          type: this.status,
          pageNum: 0,
          pageSize: this.page.pageLeng,
          ib_id: this.proxyAccount,
          report_id: this.queryObj.REPORT_ID
        }
      };
    }
  },
  mounted() {
    this.area = JSON.parse(sessionStorage.getItem("area")).GM;
    this.queryObj = this.$route.query;
    this.timeDiff = getTimeDiff();
    let sinStr = sessionStorage.getItem("back");
    if (sinStr) {
      let sinObj = JSON.parse(sinStr);
      let secondBack = sinObj.secondBack;
      if (secondBack) {
        this.status = secondBack.status;
        this.proxyAccount = secondBack.id;
        this.report_id = secondBack.report_id;
        this.page.active = secondBack.pageNum + 1;
        this.selPage.limit = secondBack.pageSize;
      }
      //this.tableAjax()
      delete sinObj.secondBack;
      sessionStorage.setItem("back", JSON.stringify(sinObj));
    }
    this.tableAjax();
  },
  methods: {
    searchDatas() {
      this.page.active = 1;
      this.tableAjax();
    },
    tableAjax() {
      this.loading = true;
      this.changeTime = true;
      this.url = api.getUrl20(this.curArea, URL_CPA);
      let tableObj = {
        params: {
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit,
          type: this.status,
          ib_id: this.proxyAccount,
          report_id: this.queryObj.REPORT_ID
        }
      };
      this.$http.get(this.url, tableObj).then(res => {
        this.trData = res.data.data.rows;
        this.page.pageLeng = res.data.data.count;
        this.setOfficeState();
        this.loading = false;
      });
    },
    setOfficeState() {
      let list = this.CPACommLan.CPAStatusList;
      if (Object.prototype.toString.call(this.trData) == "[object Array]") {
        this.trData.forEach((item, index) => {
          item.checked = false;
          item.status =
            item.STATUS || item.STATUS == 0 ? list[item.STATUS] : "";
          item.TYPE = 2;
          if (this.changeTime)
            item.LAST_UPDATE = updateTimeByUtc(this.timeDiff, item.LAST_UPDATE);
        });
      }
    }
  },
  watch: {
    CPACommLan() {
      this.changeTime = false;
      this.setOfficeState();
    },
    curArea(newVal) {
      this.status = -1;
      this.proxyAccount = "";
      this.page.active = 1;
      if (this.area.indexOf(this.curArea) > -1) this.$router.push("ibSetting");
      else this.tableAjax();
    }
  },
  components: {
    mtable
  }
};
</script>
<style lang="scss" type="text/scss" scoped>
.title-box {
  border: 1px solid #3f51b5;
  background: #3f51b5;
  padding: 0 20px;
  color: #fff;
  border-radius: 5px 5px 0 0;
  .preview-btn {
    border: 1px solid #f08712;
    background-color: #f08712;
    border-radius: 5px;
  }
}
.filterCond {
  float: left;
  .commission-condition {
    float: left;
    margin-right: 30px;
    .commission-search {
      float: left;
      margin-right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// CPAMonthlyCommResult.vue?544c13a8